// pages/TestimonialsPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { testimonials } from '../data/constants';
import Button from '../components/ui/Button';
import Section from '../components/layout/Section';
import { trackCtaClick } from '../utils/tracking';

const TestimonialsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="pt-20">
      <Section title="What Our Customers Are Saying" bg="bg-slate-50">
        <p className="text-center text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
          We're proud of the reputation we've built based on hard work, quality service, and customer satisfaction. Here's what some of our valued homeowners have to say.
        </p>
        
        <div className="text-center mb-12">
          <a 
            href="https://maps.app.goo.gl/XhFZ9BWobyGZ2hnR9"
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
          >
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              ))}
            </div>
            <span className="text-gray-700 font-medium">Read our Google Reviews</span>
          </a>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg border-l-4 border-lime-500">
              <p className="text-gray-700 italic text-lg mb-6">"{testimonial.quote}"</p>
              <p className="text-right font-semibold text-slate-800">- {testimonial.author}</p>
              <p className="text-right text-sm text-gray-500">{testimonial.location}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-16">
          <Button onClick={() => { trackCtaClick('/request-quote', 'Join Our Satisfied Customers!'); navigate('/request-quote'); }} variant="primary" className="text-lg">
            Join Our Satisfied Customers!
          </Button>
        </div>
      </Section>
    </div>
  );
};

export default TestimonialsPage;
